import { Controller } from '@hotwired/stimulus';
import 'summernote/dist/summernote-bs4.css';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'label',
        'arrow',
    ];

    static values = {
        expanded: { type: Boolean, default: false },
    };

    connect() {
        const textarea = this.labelTarget.nextElementSibling;

        if (!this.expandedValue) {
            textarea.classList.add('d-none');
        } else {
            this.arrowTarget.classList.add('arrow-rotate');
        }

        this.labelTarget.addEventListener('click', () => {
            textarea.classList.toggle('d-none');
            this.arrowTarget.classList.toggle('arrow-rotate');
        });
    }
}